import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articleContents';

export default function KakobuyClothingSpreadsheet() {
  return <ArticleLayout content={allArticles[4]} />;
}